import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-safety',
  templateUrl: './safety.component.html',
  imports: [AnimateOnScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SafetyComponent {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().safety);

  points = computed(() => this.t().points);

  pointIcons = [
    'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z', // Certificate / Checkmark
    'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z', // Magnifying glass
    'M12 2L2 7l10 12L22 7l-10-5z', // Diamond for quality
    'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' // Shield for PPE
  ];
}